import React from "react";

import * as Log from "~/Log";
import { Time } from "~/Time";
import * as Typography from "~/Typography";

export const Component: React.Fn<Log.Violation.Violation> = (violation) =>
  violation.container.type === Log.Violation.Container.Type.breakViolation() ? (
    <Typography.Component>
      No required&nbsp;
      <Typography.Component strong>30 minute break</Typography.Component>
      &nbsp;for the <Container.Component {...violation} />.
    </Typography.Component>
  ) : (
    <Typography.Component>
      Limit of <Limit.Component {...violation} /> exceeded for the&nbsp;
      <Container.Component {...violation} />.
    </Typography.Component>
  );

namespace Container {
  export const Component: React.Fn<{
    readonly container: Log.Violation.Container.Container;
  }> = ({ container }) => (
    <>
      <Type.Component {...container} /> starting&nbsp;
      <Timing.Component {...container} />
    </>
  );

  export namespace Type {
    export const Component: React.Fn<{
      readonly type: Log.Violation.Container.Type.Type;
    }> = ({ type }) => (
      <Typography.Component strong>
        {type === Log.Violation.Container.Type.cycleViolation()
          ? "cycle"
          : "shift"}
      </Typography.Component>
    );
  }

  namespace Timing {
    export const Component: React.Fn<{
      readonly timing: Log.Violation.Container.Timing.Timing;
    }> = ({ timing }) =>
      "dateTime" in timing ? (
        <Time.DateTime {...timing} />
      ) : (
        <Time.Interval
          {...timing}
          Separator={() => <> and ending </>}
          Duration={() => null}
        />
      );
  }
}

namespace Limit {
  export const Component: React.Fn<Pick<Log.Violation.Violation, "limit">> = ({
    limit,
  }) => (
    <Typography.Component strong>
      {Time.Duration.toEnglishHours(limit)}
    </Typography.Component>
  );
}
